export default __webpack_public_path__ + "static/media/480_dummy2016-personaltrainer01-mobile-de.93a3cdb2.png";